export default __webpack_public_path__ + "static/reaction-devel-182600242eeff05d5c217f06602e06bd.png";